import { useState } from 'react'

import { CitationResult } from '@/common/model/media/citation'

import CitationActionPanel from './CitationActionPanel'
import CitationDomainChart from './CitationDomainChart'
import CitationGenreChart from './CitationGenreChart'
import CitationPageList from './CitationPageList'
import CitationStrategyPanel from './CitationStrategyPanel'

interface Props {
  result: CitationResult
  siteId: number
  historyId: number
}

// サイテーション分析の結果ビュー全体
const CitationResultView = ({ result, siteId, historyId }: Props) => {
  // ジャンルチャートとページ一覧で共有するカテゴリ選択
  const [selectedCategory, setSelectedCategory] = useState('')

  const brands = result.brands ?? []
  const compName = brands[1]?.name
  const actions = result.strategy?.strategy?.actions ?? []

  return (
    <>
      {actions.length > 0 && (
        <CitationActionPanel actions={actions} siteId={siteId} historyId={historyId} />
      )}

      {result.strategy && (result.strategy.comparison || result.strategy.strategy) && (
        <CitationStrategyPanel strategy={result.strategy} brands={brands} />
      )}

      <CitationGenreChart
        brands={brands}
        categoryChart={result.category_chart ?? []}
        ownCount={result.own_count ?? 0}
        competitorCount={result.competitor_count ?? 0}
        selectedCategory={selectedCategory}
        onSelectCategory={setSelectedCategory}
      />

      <CitationDomainChart
        brands={brands}
        domainChart={result.domain_chart ?? []}
        compOnlyDomains={result.comp_only_domains ?? []}
        competitorName={compName}
      />

      <CitationPageList
        citations={result.citations ?? []}
        selectedCategory={selectedCategory}
        onSelectCategory={setSelectedCategory}
      />
    </>
  )
}

export default CitationResultView
